import { createAsyncThunk } from '@reduxjs/toolkit';
import { AICoachShiftImpactApi, GetShiftImpactParams, ShiftImpact } from 'api/AICoachShiftImpactApi';

import { ErrorResponse } from './ErrorResponse';

export const createGetShiftImpactThunk = (api: AICoachShiftImpactApi) =>
  createAsyncThunk('shiftImpact/getShiftImpact', async (params: GetShiftImpactParams, thunkApi) => {
    try {
      const response: ShiftImpact = await api.getShiftImpact(params);
      return response;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue((error as ErrorResponse).response.data);
    }
  });
